import { SuccessPlanContext } from "components/summary/success-plan";
import { useContext } from "react";

export function useSpContext() {
  const ctx = useContext(SuccessPlanContext);
  if (!ctx) {
    throw new Error("useSpContext must be used within a SuccessPlanContext");
  }
  return ctx;
}
